export default "__VITE_ASSET__CokiiUA___"